module.exports = __webpack_public_path__ + "img/sy@2x.0a7ece81.png";